var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.osCounter),function(count,os){return _c('span',{key:os,staticClass:"mr-2"},[_c('os-icon',{attrs:{"os":os}}),_c('span',[_vm._v("x"+_vm._s(count))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }